/**
   Tint Shader

 */

import THREE from 'three';
import vertexShader from './Ortho.vert.glsl';
import fragmentShader from './TintShader.frag.glsl';
import {ShaderWithUniforms, TintShaderUniforms} from '../../types/shader.types';

export const TintShader: ShaderWithUniforms<TintShaderUniforms> = {
  uniforms: {
    tDiffuse: {value: null},
    color: {
      value: new THREE.Color(0xff0000),
    },
    amount: {
      value: 0.1,
    },
  },
  vertexShader: vertexShader,
  fragmentShader: fragmentShader,
};
